<template>
  <div class="TupianBreadcrumbs inner_center">
    <i class="icon_maodian" />
    <div class="breadcrumbs">
      <div class="breadcrumbs-item">
        <a
          :href="tupianLink "
          class="">
          全部热点
        </a>
        <i class="iconfont icon-a-arrowright" v-if="breadcrumbs.length" />
      </div>
      <div
        v-for="vo in breadcrumbs"
        :key="vo.id"
        class="breadcrumbs-item border">
        <a
          :href="vo.path"
          target="_blank"
        >
          {{ vo.name }}
          <span
            class="iconfont icon-cha"
            @click.stop.prevent="remove(vo)"
          />
        </a>
        <i class="iconfont icon-a-arrowright" />
      </div>
    </div>
  </div>
</template>

<script>
import {parseListUrl} from "@/components/list/module";
import {MATERIAL_LIST_PATH} from "@/constant/PATH";
import {fnRouter} from "@/fn";
import {PAGE_PATH} from "@/constant/PAGE_PATH";

export default {
  name: "TupianBreadcrumbs",
  props: {
    breadcrumbs:{
      type: Array,
      default:()=>[]
    }
  },
  computed:{
    /* 全部热点 */
    tupianLink(){
      return fnRouter.getRouterLink(PAGE_PATH.TU_PIAN.LIST);
    },
    /* vip介绍页 */
    vipIntroLink(){
      return fnRouter.getRouterLink(PAGE_PATH.INTRODUCE.VIP);
    }

  },
  methods:{
    remove(vo){
      console.log(vo.type)
      let id = this.$route.params.id;
      let routerPath = this.$route.path;
      let params = parseListUrl(routerPath, id)
      if (vo.type == 'home_keyword_id'){
        params.home_keyword_id = 0
        params.module = 0
        params.category = 0
        params.scene = 0
      }else if (vo.type == 'module'){
        params.module = 0
        params.category = 0
        params.scene = 0
      }else if (vo.type == 'scene'){
        params.scene = 0
      }else if (vo.type == 'category'){
        params.category = 0
      }else {
        params.pinyin = 0
      }
      console.log({
        params
      })
      let {pinyin, home_keyword_id, layout, time_filter, module,category, scene, page, desc} = params;
      let path = MATERIAL_LIST_PATH + `/${pinyin}-${home_keyword_id}-${layout}-${time_filter}-${module}-${category}-${scene}-${desc}-1.html`;
      fnRouter.navigationTo(path, '_self');
    }
  }
}
</script>

<style lang="scss" scoped>
.TupianBreadcrumbs{
  display: flex;
  align-items: center;
  margin: 12px auto;
  color: rgba(0, 16, 19, 0.45);
  //font-size: 0;

  a{
    font-size: 12px;
    line-height: 20px;
    color: rgba(0, 16, 19, 0.45);
    @include ElementHover(rgba(66, 72, 102, 0.85),'');
  }

  .icon_maodian{
    @include BgImage(16px,16px,'tupian/maodian.svg');
    margin-right: 8px;
  }

  .breadcrumbs{
    display: flex;
    align-items: center;
    font-size: 0;

    .breadcrumbs-item {


      &.border{

        &:last-child{
          .icon-a-arrowright{
            display: none;
          }
        }
        a{
          height: 26px;
          line-height: 26px;
          box-sizing: border-box;
          background: #FFFFFF;
          border-radius: 4px;
          border: 1px solid #F0F0F1;
          padding: 0 8px;
          display: inline-flex;
          align-items: center;

          .icon-cha{
            margin-left: 2px;
            font-size: 10px;
            position: relative;
            top: 1px;
          }
        }


      }
    }
  }
  .icon-a-arrowright{
    font-size: 14px;
    margin: 0 2px;
  }
}
</style>
